export const LUXURY_ESCAPES = 'luxuryescapes'
export const CUDO_TRAVEL = 'cudotravel'
export const DEALS_TRAVEL = 'dealstravel'
export const SCOOPON_TRAVEL = 'scoopontravel'
export const TREATME_TRAVEL = 'treatmetravel'
export const LE_BUSINESS_TRAVELLER = 'lebusinesstraveller'
export const LE_AGENT_HUB = 'leagenthub'
